import { Link } from 'react-router-dom'

export function NotFoundPage() {
  return (
    <section aria-labelledby="not-found-heading">
      <h1 id="not-found-heading" className="display-heading">
        Page not found
      </h1>
      <p>The page you&apos;re looking for doesn&apos;t exist or has moved.</p>
      <Link to="/">Back to home</Link>
    </section>
  )
}
